import { render, staticRenderFns } from "./BasicDetailsForm.vue?vue&type=template&id=e0e4937a"
import script from "./BasicDetailsForm.vue?vue&type=script&lang=js"
export * from "./BasicDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports